export default "__VITE_ASSET__BBZZcYbM__"